import { render } from "./IntegrationOwnerBadge.vue?vue&type=template&id=5d5e2c4b&scoped=true"
import script from "./IntegrationOwnerBadge.vue?vue&type=script&lang=ts"
export * from "./IntegrationOwnerBadge.vue?vue&type=script&lang=ts"

import "./IntegrationOwnerBadge.vue?vue&type=style&index=0&id=5d5e2c4b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d5e2c4b"

export default script